<template>
    <div class="my-tcinfo">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="tc-items" v-for="item in miList">
            <div style="font-size: 13px;border-bottom: #EEEEEE solid 1px;padding-bottom: 5px">
                <span>套餐名称：{{item.tcName}}</span>
            </div>
            <div class="tc-item">
                <div class="tcinfo" style="border-bottom: 10px">
                    <span class="tci1">内容</span>
                    <span class="tci2">已使用</span>
                    <span class="tci2">剩余次数</span>
                </div>
                <div class="tcinfo" v-for="item in item.smis">
                    <span class="tci1">{{item.itemName}}</span>
                    <span class="tci2">{{item.uses}}</span>
                    <span class="tci2">{{item.yu}}</span>
                </div>
            </div>
            <div style="font-size: 12px;margin-top: 12px">有效期: {{item.dueDate==null?'不限制':item.dueDate}}</div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        data() {
            return {
                title: '套餐管理',
                deptId: '',
                token: '',
                miList: [],
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.memberId=this.$route.query.memberId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getMdTc()
        },
        methods: {
            async getMdTc() {
                let data = {
                    memberId: this.memberId
                }
                let res = await this.$get("/fw/getFwMemberItems", data)
                this.miList = res.list
            },
            onChange(index) {
                this.current = index;
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-tcinfo {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .tc-items {
        width: 96%;
        margin: auto;
        border-bottom: 5px;
        background-color: #ffffff;
        padding: 16px;
        margin-bottom: 8px;
    }

    .tc-item {
        margin-top: 8px;
        background-color: #F8F8F8;
        padding: 8px 12px;
        display: flex;
        flex-direction: column;
    }

    .tcinfo {
        display: flex;
        flex-direction: row;
        font-size: 12px;
        margin-bottom: 8px;
    }

    .tci1 {
        width: 50%;
    }

    .tci2 {
        width: 25%;
    }

</style>
